import { Text } from '@mantine/core';
import React, { FC } from 'react';
import { Link } from 'react-router-dom';

import { AuditLogType } from '@portals/types';

interface CreateModelProps {
  auditLog: AuditLogType;
}

export const CreateModel: FC<CreateModelProps> = ({ auditLog }) => (
  <Text size="sm">
    Created {auditLog?.params[0]?.model}:{' '}
    <Text<typeof Link>
      size="sm"
      component={Link}
      to={`/models/${auditLog?.params[0]?.id}`}
      color="blue"
      underline
    >
      {auditLog?.params[0]?.display_name}
    </Text>
  </Text>
);
